var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoVSafe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "225px",
    height: "225px",
    viewBox: "0 0 225 225",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ico_v_safe") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-24.2%",
    y: "-24.2%",
    width: "148.5%",
    height: "148.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.HOME-PROPOSTA-d",
    transform: "translate(-511.000000, -1209.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico_v_safe",
    filter: "url(#filter-1)",
    transform: "translate(541.000000, 1239.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    opacity: 0.927315848,
    cx: 82.3170274,
    cy: 82.3170274,
    r: 82.3170274
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-8",
    fillOpacity: 0.810068837,
    fill: "#FFFFFF",
    opacity: 0.852329799,
    cx: 82.5,
    cy: 82.5,
    r: 74.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7426471,72.4847561 L66.7426471,66.7586382 C66.7426471,57.4887428 74.2308648,50 83.5,50 C92.7691845,50 100.257353,57.4887921 100.257353,66.7586382 L100.257353,72.4847561 L105.233597,72.4847561 C107.86037,72.4847561 110,74.6245499 110,77.2515244 L110,104.233232 C110,106.860206 107.86037,109 105.233597,109 L61.7664027,109 C59.1396297,109 57,106.860206 57,104.233232 L57,77.2515244 C57,74.6245499 59.1396297,72.4847561 61.7664027,72.4847561 L66.7426471,72.4847561 Z M97.1456749,72.2459016 L97.1456749,66.3997717 C97.1456749,58.907013 91.0045039,52.9016393 83.342314,52.9016393 C75.6801242,52.9016393 69.5389532,58.907013 69.5389532,66.3997717 L69.5389532,72.2459016 L97.1456749,72.2459016 Z M60.7060786,75.5227024 C59.9828927,75.5227024 59.4288503,76.0764638 59.4288503,76.7992829 L59.4288503,104.82178 C59.4288503,105.544599 59.9828927,106.098361 60.7060786,106.098361 L105.876346,106.098361 C106.599532,106.098361 107.153574,105.544599 107.153574,104.82178 L107.153574,76.7992829 C107.153574,76.0764638 106.599532,75.5227024 105.876346,75.5227024 L60.7060786,75.5227024 Z M79.1636364,87.7917396 C79.1636364,85.0881165 81.272777,82.8852459 83.8613636,82.8852459 C86.4499503,82.8852459 88.5590909,85.0881165 88.5590909,87.7917396 C88.5590909,88.9282009 88.15274,89.9797177 87.4352327,90.8658888 L87.4352327,93.6607512 C87.4352327,95.7178441 85.8309292,97.3934426 83.8613636,97.3934426 C81.8917981,97.3934426 80.2874946,95.7178441 80.2874946,93.6607512 L80.2874946,90.8658753 C79.5699731,89.9796483 79.1636364,88.9281912 79.1636364,87.7917396 Z M81.0909091,87.3541756 C81.0909091,88.0900482 81.4379883,88.7594003 82.0363887,89.2300913 C82.4415735,89.5401128 82.6793028,89.9931152 82.6793028,90.465766 L82.6793028,94.3170972 C82.6793028,94.9636691 83.2443143,95.4590164 83.9818182,95.4590164 C84.719322,95.4590164 85.2843336,94.9636691 85.2843336,94.3170972 L85.2843336,90.465766 C85.2843336,89.9931152 85.5220628,89.5401128 85.9162336,89.2386351 C86.5256499,88.7593784 86.8727273,88.0900369 86.8727273,87.3541756 C86.8727273,85.9460815 85.5879392,84.8196721 83.9818182,84.8196721 C82.3756971,84.8196721 81.0909091,85.9460815 81.0909091,87.3541756 Z",
    id: "Shape",
    fill: "#FCBB00",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(54.416576, 103.742007)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoVSafe);
export default __webpack_public_path__ + "static/media/ico_v_safe.9de6566235506d41e9edafdd872b4fdd.svg";
export { ForwardRef as ReactComponent };